import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/chart-up.svg";
var ChartUpOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ChartUpOutline_default as default
};
